import { AddLeaderboardNavItem } from '@/connection/leaderboard';
import { serializeError } from '@/store/utils/serialize-error';
import { ProjectStateReducerCreator } from '../types';

const addLeaderboardNavItemReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async (data: { eventUuid: string; homepageId: number }, { rejectWithValue }) => {
      try {
        return await AddLeaderboardNavItem(data.eventUuid, data.homepageId);
      } catch (error) {
        return rejectWithValue(serializeError(error));
      }
    },
    {
      fulfilled: (state, action) => {
        if (action.payload && state?.workingProject?.homepage?.event_main_nav_items) {
          state.workingProject.homepage.event_main_nav_items = [
            ...state.workingProject.homepage.event_main_nav_items,
            action.payload,
          ];
        }
      },
    }
  );
};

export default addLeaderboardNavItemReducer;
